module.exports = __webpack_public_path__ + "img/weight2.55e42bf1.svg";